import { createContext, useContext } from "react";

const SidebarPortalContext = createContext({
  portalContainer: null,
});

export function SidebarPortalProvider({ portalContainer, children }) {
  return (
    <SidebarPortalContext.Provider value={{ portalContainer }}>
      {children}
    </SidebarPortalContext.Provider>
  );
}

/** When used inside {@link Sidebar}, returns the sidebar root for portaling overlays (e.g. tenant switcher). */
export function useSidebarPortalContainer() {
  const { portalContainer } = useContext(SidebarPortalContext);
  return portalContainer ?? undefined;
}
